import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface ParameterState {
  parameterData: any[] | null;
  parameterSearchData: any[] | null;
  parameterTotalRecords: number;
  parameterCategoryData: any[] | null;
  parameterCategorySearchData: any[] | null;
  parameterCategoryTotalRecords: number;
}

const initialState: ParameterState = {
  parameterData: null,
  parameterSearchData: null,
  parameterTotalRecords: 0,
  parameterCategoryData: null,
  parameterCategorySearchData: null,
  parameterCategoryTotalRecords: 0,
};

export const parameterSlice = createSlice({
  name: 'parameter',
  initialState,
  reducers: {
    setParameterData: (state, action) => {
      const data = action.payload.data || action.payload;
      state.parameterData = Array.isArray(data) ? data.map((item: any) => ({ ...item, id: item.parameterId || item.id })) : data;
      state.parameterTotalRecords = action.payload.totalRecords || 0;
    },
    setParameterSearchData: (state, action) => {
      const data = action.payload.data || action.payload;
      state.parameterSearchData = Array.isArray(data) ? data.map((item: any) => ({ ...item, id: item.parameterId || item.id })) : data;
    },
    setParameterCategoryData: (state, action) => {
      const data = action.payload.data || action.payload;
      state.parameterCategoryData = Array.isArray(data) ? data.map((item: any) => ({ ...item, id: item.categoryId || item.id })) : data;
      state.parameterCategoryTotalRecords = action.payload.totalRecords || 0;
    },
    setParameterCategorySearchData: (state, action) => {
      const data = action.payload.data || action.payload;
      state.parameterCategorySearchData = Array.isArray(data) ? data.map((item: any) => ({ ...item, id: item.categoryId || item.id })) : data;
    },
  },
});

export const {
  setParameterData,
  setParameterSearchData,
  setParameterCategoryData,
  setParameterCategorySearchData,
} = parameterSlice.actions;

export const getAllParameterData = (state: RootState) => state.parameter.parameterData;
export const getParameterSearchData = (state: RootState) => state.parameter.parameterSearchData;
export const getParameterTotalRecords = (state: RootState) => state.parameter.parameterTotalRecords;
export const getAllParameterCategoryData = (state: RootState) => state.parameter.parameterCategoryData;
export const getParameterCategorySearchData = (state: RootState) => state.parameter.parameterCategorySearchData;
export const getParameterCategoryTotalRecords = (state: RootState) => state.parameter.parameterCategoryTotalRecords;

export default parameterSlice.reducer;
